import { Injectable } from '@angular/core';
import { DefaultService } from '@common/references/default.service';
import { UtilityTypesFormComponent } from '@modules/settings/utility-types/utility-form/utility-types-form.component';
import { environment } from '@environments/environment';
import urlJoin from 'url-join';
import { ReferenceField } from '@common/references/reference-field';
import { UtilityProviderType } from '@modules/settings/utility-types/utility-types.interfaces';

@Injectable({
  providedIn: 'root',
})
export class UtilityProviderTypesService extends DefaultService<UtilityProviderType> {
  backendName = 'utility-provider-types';
  formComponent = UtilityTypesFormComponent;
  title = 'MENU.UTILITY_TYPES';
  titleSingular = 'UTILITY_TYPE';
  fields: ReferenceField[] = [

    {fieldName: 'type', label: 'MENU.UTILITY_TYPES', iconClass: 'las la-cube', viewType: 'unitType', filter: true},
    {
      fieldName: 'utilityProvider',
      fieldValue: 'name',
      label: 'MENU.UTILITY_PROVIDERS',
      iconClass: 'las la-toggle-on',
      filter: true
    },

  ];
  hasActions = true;
  hasAdd = true;
  hasDelete = true;

  getUrl(): string {
    return urlJoin(environment.apiUrl, 'utility-provider-types');
  }

}
